export default {
	type: 'BLURB_6',
	name: 'Blurb 6',
	allowedSections: ['main', 'header'],
	disallowedChildren: ['*'],
	category: 'Blurbs',
	props: [{
		name: 'imgSrc',
		inputType: 'media',
		label: 'Image path',
		default: ''
	}, {
		name: 'imgUrl',
		inputType: 'link',
		label: 'Image link',
		default: '',
		requestKey: 'linkFriendlyName'
	}, {
		name: 'title',
		inputType: 'text',
		label: 'Title',
		default: 'Title'
	}, {
		name: 'text',
		inputType: 'text',
		label: 'Text',
		default: 'Lorem ipsum...'
	}, {
		name: 'showButtonOne',
		inputType: 'checkbox',
		label: 'Show button one',
		default: true
	}, {
		name: 'buttonTextOne',
		inputType: 'text',
		label: 'Button text',
		default: 'Men'
	}, {
		name: 'navUrlOne',
		inputType: 'link',
		label: 'Button url',
		default: ''
	}, {
		name: 'showContentOnHover',
		inputType: 'checkbox',
		label: 'Show button two on hover',
		default: true
	}, {
		name: 'buttonTextTwo',
		inputType: 'text',
		label: 'Button text',
		default: 'Lady'
	}, {
		name: 'navUrlTwo',
		inputType: 'link',
		label: 'Button url',
		default: ''
	}],
	hiddenProps: [{
		label: 'Content Alignment',
		props: [{
			name: 'align',
			inputType: 'select',
			label: 'Text alignment',
			default: 'Blurb6-flex--textCenter',
			values: [{
				label: 'Left',
				value: 'Blurb6-flex--textLeft'
			}, {
				label: 'Center',
				value: 'Blurb6-flex--textCenter'
			}, {
				label: 'Right',
				value: 'Blurb6-flex--textRight'
			}]
		}, {
			name: 'marginLeft',
			inputType: 'number',
			label: 'Margin left',
			default: '0'
		}, {
			name: 'marginRight',
			inputType: 'number',
			label: 'Margin right',
			default: '0'
		}, {
			name: 'marginTop',
			inputType: 'number',
			label: 'Margin top',
			default: '0'
		}, {
			name: 'marginBottom',
			inputType: 'number',
			label: 'Margin bottom',
			default: '0'
		}]
	}, {
		label: 'Advanced settings',
		props: [{
			name: 'class',
			inputType: 'text',
			label: 'CSS-class',
			default: ''
		}]
	}]
};
